import { MoonStar, SunMedium } from 'lucide-react';
import { useTheme } from '@/components/theme-provider';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function ModeToggle() {
  const { theme, toggleTheme } = useTheme();

  const isDark = theme === 'dark';

  return (
    <Button
      aria-label={isDark ? 'Activer le thème clair' : 'Activer le thème sombre'}
      className='relative'
      onClick={toggleTheme}
      size='icon'
      type='button'
      variant='ghost'
    >
      <SunMedium
        className={cn(
          'size-4 rotate-0 scale-100 transition-all duration-200',
          isDark && 'rotate-90 scale-0 opacity-0',
        )}
      />
      <MoonStar
        className={cn(
          'pointer-events-none absolute size-4 rotate-90 scale-0 opacity-0 transition-all duration-200',
          isDark && 'rotate-0 scale-100 opacity-100',
        )}
      />
      <span className='sr-only'>
        {isDark ? 'Passer au thème clair' : 'Passer au thème sombre'}
      </span>
    </Button>
  );
}
